"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficePdftemplates_en_us = void 0;
function backofficePdftemplates_en_us() {
    return {
        "backoffice.pdftemplates.template.title": "PDF Template title",
        "backoffice.pdftemplates.title": "PDF Templates",
        "backoffice.pdftemplates.subtitle": "Create and manage pdf templates for example your invoices.",
        "backoffice.pdftemplates.create.title": "Create PDF Template",
        "backoffice.pdftemplates.creationdialog.title": "Create PDF Template",
        "backoffice.pdftemplates.creationdialog.description": "Enter a title to create a new PDF Template.",
        "backoffice.pdftemplates.deletion.title": "Delete PDF Template",
        "backoffice.pdftemplates.deletion.message": "Do you really want do delete this PDF Template?",
        "backoffice.pdftemplates.edit.title": "Edit PDF Template",
        "backoffice.pdftemplates.editor.title.label": "PDF Template title"
    };
}
exports.backofficePdftemplates_en_us = backofficePdftemplates_en_us;
